/* eslint-disable no-param-reassign */
import SpecProcessor, { type Spec as CommonSpec, type Data } from './specProcessor';
import type { StandardChartLayerSpec } from '../../core/layer';

export type Spec = {
  layers: Partial<StandardChartLayerSpec>[];
} & CommonSpec;

export default class StandardChartSpecProcessor extends SpecProcessor {
  static preprocessing(data: Data, spec: Spec): boolean {
    return (
      StandardChartSpecProcessor.isDataValid(data, spec) &&
      (StandardChartSpecProcessor.isEncodingValid(data, spec) as boolean)
    );
  }
}
